import {
  getProgress,
  isCourseEnrolled,
  isLessonComplete,
  getNextIncompleteLesson,
  getNextLesson,
  getPreviousLesson,
  getCompletedAt,
} from './helpers'
import markdownIt from 'markdown-it'
const md = markdownIt()

export default function ({ status, data }, user) {
  let html = null
  let markdown = null
  let meta
  if (data && data.content) {
    html = md.render(data.markdown)
    markdown = data.markdown
  } 
  if (user) {
    meta = {
      description: data.description,
      markdown: data.markdown,
      content: data.content
    }
  } else {
    meta = {
      description: data.description,
      markdown: data.markdown,
      content: data.content    }
  }
  delete meta.markdown
  const lessons = data.lessons.map(lesson => ({
    id: lesson.id,
    title: lesson.title,
    order: lesson.order,
    complete: user ? isLessonComplete(data.id, lesson.id, user) : null,
    completedAt: user ? getCompletedAt(data.id, lesson.id, user) : null,
    meta: {
      description: lesson.description,
      markdown: lesson.markdown,
      content: lesson.content    
    }
  })).sort((a, b) => (a.order >= b.order ? 1 : -1))
  const nextIncompleteLesson = user ? getNextIncompleteLesson(lessons) : null
  return {
    status,
    course: {
      id: data.id,
      title: data.title,
      createdAt: data.createdAt,
      updatedAt: data.updatedAt,
      enrolled: isCourseEnrolled(data.id, user),
      getNextLesson: (currentLessonId) => getNextLesson(currentLessonId, lessons),
      nextIncompleteLesson: nextIncompleteLesson,
      getPreviousLesson: (currentLessonId) => getPreviousLesson(currentLessonId, lessons),
      // deprecating nextLessonId in v1
      nextLessonId: nextIncompleteLesson ? nextIncompleteLesson.id : null,
      progress: user ? getProgress(lessons): null,
      lessons,
      meta,
      markdown,
      html,
    }
  }
}
